import React from "react";
import Switch from "@material-ui/core/Switch";
import { useN01SwitchStyles } from "@mui-treasury/styles/switch/n01";

const OnOffSwitch = ({ title, value, handleClick }) => {
    const switchStyles = useN01SwitchStyles();
    const [toggled, setToggled] = React.useState(value);

    const handleChange = (event) => {
        // console.log("handling change " + event);
        handleClick();
    };

    React.useEffect(() => {
        setToggled(value);
    }, [value]);
    return (
        <div style={{ margin: "0px" }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    textJustify: "center",
                    height: "100%",
                }}
            >
                {/* <p style={{ margin: "0 10px", alignSelf: "center" }}>{title}: </p> */}
                <Switch
                    classes={switchStyles}
                    checked={toggled}
                    onClick={(e) => {
                        handleChange();
                        setToggled(e.target.checked);
                    }}
                />
            </div>
        </div>
    );
};

export default OnOffSwitch;
